<div class="login-hero my-4" *ngIf="!uploading">
  <img *ngIf="hasImage" class="login-hero-preview" [src]="heroUrl" alt="Login hero image" (error)="onPreviewError()" />
  <div class="login-hero-empty" *ngIf="!hasImage">No image set. The app color is used on the login pages.</div>
</div>
<app-file-upload
  [(uploadProgress)]="uploadProgress"
  [(uploading)]="uploading"
  [disabled]="false"
  (upload)="uploadHero($event)"
  [fileTypes]="imageFormats"
  [confirm]="false"
  [multiple]="false"
  [buttonText]="hasImage ? 'Change' : 'Upload'"
  [icon]="hasImage ? 'sync' : 'plus-circle'"
></app-file-upload>
<small class="form-text text-muted d-block mt-2">
  Landscape photo, at least 1600 px wide, with the subject in the center. It is shown next to the login, register and password forms.
</small>
